import CONF from "../config/config";
import Package from './../../package.json';

const selectedFacility = JSON.parse(localStorage.getItem('selectedFacility'));
const user = JSON.parse(localStorage.getItem('user'));

//webhook url api call
var apiCall = (webhookUrl, requestData) => {
    if (!webhookUrl || !requestData) {
        return;
    }

    var xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
            console.log("Data successfully sent");
        }
    };

    xhttp.open("POST", webhookUrl, true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send(JSON.stringify(requestData));
}

//Events sent to hevo_bradman_web_inbound_app_evenTS on redshift
export function sendEventToHevo(eventName, eventData) {
    if (!eventName || !eventData) {
        return;
    }

    eventData["event_name"] = eventName;
    eventData["fc_user_id"] = user ? user.bradmanUserProfile.emailId : null;
    eventData["geo_fc"] = selectedFacility ? selectedFacility.facilityName : null;
    if (!eventData.timestamp) eventData.timestamp = new Date().getTime()

    var requestData = {
        event: 'inbound_app_events',
        properties: eventData,
    };

    if (CONF.superUsers.includes(user.bradmanUserProfile.emailId)) {
        console.warn('App Events');
        console.log(requestData);
    }
    else {
        var webhookUrl = "https://in-webhook.hevodata.com/t/vuzsaawwpf";
        apiCall(webhookUrl, requestData);
    }
}

//Events sent to web_bradman_errors_failure_events on redshift
export function sendEventToHevo2(eventData) {
    if (!eventData) {
        return;
    }

    eventData["fc_user_id"] = user ? user.bradmanUserProfile.emailId : null;
    eventData["geo_fc"] = selectedFacility ? selectedFacility.facilityName : null;
    eventData["web_app_version"] = '' + Package.version;
    if (!eventData.timestamp) eventData["timestamp"] = new Date().getTime();

    var requestData = {
        event: 'failure_events',
        properties: eventData,
    };
    console.log(requestData);
    var webhookUrl = "https://in-webhook.hevodata.com/t/j6yy2krmdk";
    apiCall(webhookUrl, requestData);
}


// WEBPACK FOOTER //
// ./src/utilities/manageEvents.js